export default class NLIConfig {
    helpText: string;
    examples: string[];

    constructor(helpText: string, examples: string[]) {
        this.helpText = helpText;
        this.examples = examples;
    }
}